/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface CreateUpdateTextDto
 */
export interface CreateUpdateTextDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTextDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTextDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTextDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTextDto
     */
    isUseInSetupParameter?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof CreateUpdateTextDto
     */
    setupScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateTextDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTextDto
     */
    $type?: CreateUpdateTextDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateTextDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoCreateUpdateTextDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.CreateUpdateTextDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateTextDtoTypeEnum = typeof CreateUpdateTextDtoTypeEnum[keyof typeof CreateUpdateTextDtoTypeEnum];



/**
 * Check if a given object implements the CreateUpdateTextDto interface.
 */
export function instanceOfCreateUpdateTextDto(value?: unknown): value is CreateUpdateTextDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateTextDtoTypeEnum)[0];
}

export function CreateUpdateTextDtoFromJSON(json: any): CreateUpdateTextDto {
    return CreateUpdateTextDtoFromJSONTyped(json, false);
}

export function CreateUpdateTextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateTextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isUseInSetupParameter': json['isUseInSetupParameter'] == null ? undefined : json['isUseInSetupParameter'],
        'setupScope': json['setupScope'] == null ? undefined : ((json['setupScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateUpdateTextDtoToJSON(value?: CreateUpdateTextDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'isAvailable': value['isAvailable'],
        'isUseInSetupParameter': value['isUseInSetupParameter'],
        'setupScope': value['setupScope'] == null ? undefined : ((value['setupScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value['$type'],
    });
}

